import React, { createContext, useContext, useState, useMemo } from 'react';

const MapFilterContext = createContext();

// Default theme (iWasHere.me emerald/blue)
const defaultTheme = {
  primary: 'emerald',
  secondary: 'blue',
  accent: 'emerald',
  gradientFrom: 'emerald-500',
  gradientTo: 'blue-500',
  text: 'emerald',
  background: 'emerald-50',
  border: 'emerald-200'
};

export const MapFilterProvider = ({ 
  children, 
  initialSearchTerm = '', 
  isPrivateTagFilter = false,
  initialItemTypeFilter = 'traveling',
  theme = defaultTheme 
}) => {
  const [itemTypeFilter, setItemTypeFilter] = useState(initialItemTypeFilter);
  const [searchTerm, setSearchTerm] = useState(initialSearchTerm);
  const [userLocation, setUserLocation] = useState(null);
  const [shouldZoomToUser, setShouldZoomToUser] = useState(false);
  const [privateTagMode] = useState(isPrivateTagFilter); // If true, fetch items by this tag

  // Memoize context value to prevent unnecessary re-renders
  const value = useMemo(
    () => ({ 
      itemTypeFilter, 
      setItemTypeFilter,
      searchTerm,
      setSearchTerm,
      userLocation,
      setUserLocation,
      shouldZoomToUser,
      setShouldZoomToUser,
      privateTagMode,
      initialPrivateTag: isPrivateTagFilter ? initialSearchTerm : null,
      theme
    }),
    [itemTypeFilter, searchTerm, userLocation, shouldZoomToUser, privateTagMode, initialSearchTerm, isPrivateTagFilter, theme]
  );

  return (
    <MapFilterContext.Provider value={value}>
      {children}
    </MapFilterContext.Provider>
  );
};

export const useMapFilter = () => {
  const context = useContext(MapFilterContext);
  if (!context) {
    throw new Error('useMapFilter must be used within a MapFilterProvider');
  }
  return context;
};
